import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '文博会抽奖系统';
const baseUrl = '20230331WBHCJ';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'luckdraw',
      name: `${baseUrl}-luckdraw`,
      component: () => import('./pages/LuckDraw.vue'),
      meta: {
        title: PAGE_TITLE,
        showfooter: false,
      },
    },
  ],
};

export default route;
